<template>
  <div>

    <div v-if="isKarhu">
      <div v-if="isLuettelointipyynto">
        <!-- karhu: kuvailupyyntö -->
        <i class="fa fa-bullhorn fa-lg text-muted" aria-hidden="true"></i>
        {{ query.message }}
      </div>
      <div v-else>
        <!-- karhu: kohdistamaton kysely -->
        <strong>Aineistolaji: </strong>{{ query.custom_product_group }}<br/>

        <strong>Tekijä: </strong>{{ query.prod_auth }}<br/>
        <strong>Nimike: </strong>{{ query.prod_name }}<br/>
        <strong>Kustantaja: </strong>{{ query.prod_publ }}<br/>
        <strong>Julkaisuvuosi: </strong>{{ query.publ_year }}<br/>
        <strong>Sivumäärä: </strong>{{ query.pages }}<br/>
        <strong>Koko: </strong>{{ query.size }}<br/>

        <strong>Viesti: </strong><br/>
        <div class="pre-wrap">{{ query.message }}</div>
      </div>
    </div>
    <div v-else>
      <!-- kysely: kysely/huomautus tuotteesta -->
      <div class="pre-wrap">{{ query.message }}</div>
    </div>

    <query-attachments :query="query" :current-user="currentUser" />

  </div>
</template>

<script>

import { userMixin } from '@/mixins/userMixin.js'

export default {
  components: {
  },

  mixins: [
    userMixin,
  ],

  props: {
    query: Object,
    currentUser: Object,
  },

  computed: {
    isKarhu() {
      return this.query.query_type == 'karhu'
    },

    isLuettelointipyynto() {
      return this.isKarhu && this.query.prod_id && this.query.product
    },
  },

}

</script>
